import { getters } from "@/constants/state";

export default {
  [getters.EMPLOYEE_TAGS_GETTER]: (state) => state.employeeTags,
};
